<!-- Component for the main Expansion Tab "Dashboard" -->
<template>
  <div class="border rounded-lg dark:border-dark-divider-border pb-0 bg-white dark:bg-dark-box-background">
    <div
      class="flex items-center my-2 ml-2 transition-colors ease-in-out duration-side-menu-transition-duration text-xl font-medium text-light-body-text dark:text-dark-body-text">
      {{ label }}
    </div>
    <!-- <div v-if="journeys.length == 0" class="bg-white dark:bg-dark-box-background flex justify-center min-h-[200px] rounded-lg m-2">
      <div class="flex justify-center items-center flex-col">
        <h3 class="mt-2 text-xl font-normal text-black dark:text-white">You currently don’t have any journeys</h3>
        <p class="mt-2 text-md font-normal text-gray-500">Add a new journey to get started!</p>
        <div class="primary-btn w-fit" @click="$emitter.emit('addNewJourney')">
          <Plus class="w-5 h-5 ml-1" />
          <div class="pl-1">
            <span>Create your first journey</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h1 class="leading-6 ml-4 text-lg font-medium">Filter</h1>
      <div class="ml-2.5 w-full">
        <TeamMembersSelect v-model:selected-team-members="team_members_selected" label="Team Members" />
      </div>
    </div> -->
    <div class="flex flex-row w-full h-[calc(100%-45px)]">
      <div v-if="componentType == 'summary'" class="flex flex-row w-full h-full mt-2">
        <!--Default Journey select -->
        <div class="pr-2 w-full h-full bg-white dark:bg-dark-box-background">
          <SelectDropDownMenu
            v-model:current-item="selected_journey"
            :items="journeys"
            label-attr="name"
            :value-attr="null"
            :allow-null="false"
            :clear-selection="$t('Select Main Journey')"
            :placeholder="$t('journey')"
            label="Journeys"
            classes="mb-3 pl-2"
            input-classes="sm:text-sm appearance-none font-medium text-light-body-text dark:text-dark-body-text !bg-black/0 text-left block w-full px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm" />

          <!-- Journey selection Results -->
          <div
            v-if="is_phases_loaded && selected_journey?.phases"
            class="relative flex flex-col gap-2 h-[calc(100%-56px)] overflow-y-auto overflow-x-hidden">
            <!-- Result items -->
            <div
              v-for="phase in selected_journey?.phases"
              :key="phase.id"
              class="rounded-md shadow-sm transition ease-in-out duration-side-menu-transition-duration relative max-h-full text-light-body-text dark:text-dark-body-text bg-black/0 border-light-divider-border dark:border-dark-divider-border">
              <!-- TODO I hardcoded these colors via prop rn, but you should probably go inside the component and check some condition on the phases object and set it via the computed property I set up for you -->
              <JourneySelectionResult v-if="phase?.records_count" :phase="phase" />
            </div>
          </div>
          <div v-else-if="!is_phases_loaded" class="flex items-center justify-center min-h-[200px] italic text-common-grey">
            {{ $t("Loading") }} <LoadingSpinner />
          </div>
        </div>
      </div>
      <div v-else class="w-full h-full overflow-auto">
        <div>
          <transition duration="300" mode="out-in" name="fade">
            <keep-alive>
              <JourneysMain
                v-if="componentType == 'journey'"
                v-model:current-journey="selected_journey"
                v-model:journeys="journeys"
                :object-type="current_journey?.type" />
              <DetailedJourneysView v-else :inside-component="true" :current-journey="current_journey" :journeys="journeys" />
            </keep-alive>
          </transition>
        </div>

        <div v-if="!is_phases_loaded" class="flex items-center justify-center min-h-[200px] italic text-common-grey">
          {{ $t("Loading") }} <LoadingSpinner />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Plus } from 'lucide-vue-next'
// import TeamMembersSelect from "@/components/shared/TeamMembersSelect.vue"
import JourneysMain from "@/views/dashboard/expansion/journeys/JourneysMain/index.vue"
import DetailedJourneysView from "@/views/dashboard/expansion/journeys/DetailedJourneysView/index.vue"
import JourneySelectionResult from "@/components/shared/JourneySelectionResult.vue"
import SelectDropDownMenu from "@/components/shared/SelectDropDownMenu.vue"
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue"
import dataService from "@/services/data.service"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { JourneysMain, DetailedJourneysView, JourneySelectionResult, SelectDropDownMenu, LoadingSpinner },
  props: {
    journey: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    componentType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      is_phases_loaded: false,
      is_first_load: false,
      current_journey: null,
      selected_journey: null,
      journeys: [],
      team_members_selected: [],
      is_metric_changed: false
    }
  },
  watch: {
    componentType() {
      this.init()
    },
    team_members_selected: {
      deep: true,
      handler() {
        this.filterJourneysByTeamMembers(this.current_journey)
      }
    },
    selected_journey() {
      if (this.is_first_load) {
        this.is_first_load = false
      } else {
        this.is_phases_loaded = false
        dataService.getJourney(this.selected_journey.id).then((res) => {
          this.selected_journey = res.data
          this.is_first_load = true
          this.is_phases_loaded = true
        })
      }
    }
  },
  activated() {
    this.register_listeners()
    this.init()
    if (this.journeys.length) {
      //this.$router.push(`/expansion/journeys?journey=${this.$route.query?.journey ? this.$route.query.journey : this.journeys[0].id}&object=${this.$route.query?.object ? this.$route.query?.object : this.journeys[0].type}`)
    }
  },

  created() {
    this.init()
    this.register_listeners()
  },

  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.INIT_PHASES_IN_CUSTOMER_JOURNEYS_VIEW, () => {
        this.is_metric_changed = true
      })
      this.$emitter.on(ALL_EMITTERS.UPDATE_JOURNEY_IN_CUSTOMER_JOURNEYS_VIEW, (journey) => {
        this.updateJourney(journey)
      })

      this.$emitter.on(ALL_EMITTERS.JOURNEY_DELETED_AND_DISTRIBUTION_DONE_IN_CUSTOMER_JOURENY_VIEW, (journey) => {
        if (journey.id == this.current_journey?.id || !this.current_journey?.id) {
          this.current_journey = null
          this.$router.push(`/expansion/journeys`)
        }
      })

      //Add new phase
      this.$emitter.on(ALL_EMITTERS.PHASES_ADDED_TO_CUSTOMER_JOURNEYS_VIEW, (phase) => {
        this.$store.dispatch("ui/showLoading")
        dataService.getPhase(phase.id).then((res) => {
          res.data.funnels.forEach((journey_id) => {
            let journey = this.journeys.find((fun) => fun.id == journey_id)
            if ((journey?.phases.length > 0 && typeof journey?.phases[0] != "string") || journey.phases.length == 0) {
              journey.phases.push(res.data)
              this.$utils.replaceItem(this.journeys, journey)
              if (journey_id == this.current_journey.id) {
                this.current_journey = this.$utils.clone(journey)
              }
            }
          })
          this.$store.dispatch("ui/hideLoading")
          /* this.loadPhaseCompanies(res.data).then((ph) => {
            this.updatePhaseInJourneys(ph)
          }) */
        })
      })

      //Add exisiting phase
      this.$emitter.on(ALL_EMITTERS.PHASE_MODIFIED_IN_CUSTOMER_JOURNEYS_VIEW, () => {
        this.init()
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.INIT_PHASES_IN_CUSTOMER_JOURNEYS_VIEW)
      this.$emitter.off(ALL_EMITTERS.UPDATE_JOURNEY_IN_CUSTOMER_JOURNEYS_VIEW)
      this.$emitter.off(ALL_EMITTERS.JOURNEY_DELETED_AND_DISTRIBUTION_DONE_IN_CUSTOMER_JOURENY_VIEW)
      this.$emitter.off(ALL_EMITTERS.PHASES_ADDED_TO_CUSTOMER_JOURNEYS_VIEW)
      this.$emitter.off(ALL_EMITTERS.PHASE_MODIFIED_IN_CUSTOMER_JOURNEYS_VIEW)
    },
    // updatePhaseInJourneys(phase) {
    //   phase.journeys.forEach((journey_id) => {
    //     let journey = this.journeys.find((fun) => fun.id == journey_id)
    //     if ((journey?.phases.length > 0 && typeof journey?.phases[0] != "string") || journey.phases.length == 0) {
    //       journey.phases = this.$utils.replaceItem(journey.phases, phase)
    //       this.$utils.replaceItem(this.journeys, journey)
    //       if (journey_id == this.current_journey.id) {
    //         this.current_journey = this.$utils.clone(journey)
    //       }
    //     }
    //   })
    // },
    getJourneyData(journey_id) {
      this.current_journey = this.$utils.clone(this.journeys.find((x) => x.id == journey_id))
      this.is_phases_loaded = false
      this.is_first_load = true
      dataService.getJourney(journey_id).then((res) => {
        this.current_journey = res.data
        this.selected_journey = res.data
        this.$utils.replaceItem(this.journeys, this.current_journey)
        this.is_phases_loaded = true
      })
    },

    updateJourney(journey) {
      this.$store.dispatch("ui/showLoading")
      this.current_journey = journey
      this.$utils.replaceItem(this.journeys, this.current_journey)
      this.$store.dispatch("ui/hideLoading")
    },

    filterJourneysByTeamMembers() {
      this.$store.dispatch("ui/showLoading")
      const params = {}
      if (this.team_members_selected.length) {
        params.co_owners = this.team_members_selected.map((x) => x.id).join(",")
      }
      dataService.getJourney(this.current_journey.id, params).then((res) => {
        this.current_journey = res.data
        this.$utils.replaceItem(this.journeys, this.current_journey)
        this.$store.dispatch("ui/hideLoading")
      })
    },

    init() {
      dataService.getJourneys({ page_size: 10 }).then((result) => {
        this.journeys = result.data.results
        this.getJourneyData(this.journey)
      })
    }
    // loadPhaseCompanies(phase) {
    //   if (phase?.records?.next) {
    //     return dataService.getRecordsByUrl(phase.records.next, { filter: phase.filter, filter_metrics: phase.filter_metrics }).then((result) => {
    //       phase.records.next = result.data.next
    //       phase.records.results.push(...result.data.results)
    //       return phase
    //     })
    //   }
    // }
  }
}
</script>
